import { detectOnCanvas, warpQuad, enhance, canvasToBlob } from "./docDetect";

const MAX_SIDE = 2200;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("decode")); };
    img.src = url;
  });
}

// Photo of an invoice (JPG/PNG/WebP) → cropped, flattened, contrast-boosted JPEG blob; null when no document is found.
export async function autoCropPhoto(file) {
  if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return null;
  try {
    const img = await loadImage(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
    const c = document.createElement("canvas");
    c.width = Math.round(img.naturalWidth * scale); c.height = Math.round(img.naturalHeight * scale);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    const quad = detectOnCanvas(c);
    if (!quad) return null;
    return await canvasToBlob(enhance(warpQuad(c, quad)), 0.9);
  } catch { return null; }
}
